import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store/';
import roleUtil from '@/utils/roleUtil';
import snackbar from '@/utils/snackbar';

Vue.use(VueRouter);

import routes from './routes';

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

// Router guard redirects to login if unauthenticated.
// Cancels navigation if unauthorized.
router.beforeEach((to, from, next) => {
    if (!to.matched.some(record => record.meta.requiresAuth)) {
        // Route does not require auth. Proceed
        next();
        return;
    }

    // Route requires auth. Check authentication
    if (!store.state.auth.authenticated) {
        // User is not authenticated. Redirect to login
        Vue.$log && Vue.$log.info('Redirected unauthenticated user to login.');
        next('/');
        return;
    }

    // User is authenticated. Check role
    const user = store.state.auth.user;
    if (!roleUtil.areRoutesAuthorized(user, to.matched)) {
        // User is not authorized
        Vue.$log && Vue.$log.info('Denied route to unauthorized user.');
        snackbar.show('Sorry. You are not authorized.', 'warning');
        next(false);
        return;
    }

    next();
});

export default router;
